import "core-js/modules/es.symbol";
import "core-js/modules/es.array.fill";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var Form = function Form(_ref) {
  var className = _ref.className,
      children = _ref.children,
      center = _ref.center,
      large = _ref.large,
      inverse = _ref.inverse,
      fill = _ref.fill,
      autoComplete = _ref.autoComplete,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "center", "large", "inverse", "fill", "autoComplete"]);

  var stylingClass = classnames('wds-c-form', {
    'wds-c-form--center': center
  }, {
    'wds-c-form--inverse': inverse
  }, {
    'wds-c-form-large': large
  }, {
    'wds-c-form--fill': fill
  }, className);
  return React.createElement("form", _extends({
    className: stylingClass
  }, autoComplete && {
    'autoComplete': autoComplete
  }, otherProps), children);
};

Form.propTypes = {
  /** additional styling */
  className: PropTypes.string,

  /** center the form contents */
  center: PropTypes.bool,

  /** large form */
  large: PropTypes.bool,

  /** form elements */
  children: PropTypes.node.isRequired,

  /** specifies if the form is the inverse */
  inverse: PropTypes.bool,

  /** fill the available viewport */
  fill: PropTypes.bool,

  /** provides automated assistance in filling out form field values */
  autoComplete: PropTypes.oneOf(['on', 'off'])
};
Form.defaultProps = {
  className: undefined,
  center: false,
  large: false,
  inverse: false,
  fill: false,
  autoComplete: undefined
};
export default Form;